import SearchableSelect from './SearchableSelect.jsx';
import { fieldClass, LabeledField } from './shared.jsx';

export default function RuleCalculationFields({
  form,
  errors,
  baseOptions,
  methodOptions,
  calculationSentence,
  onChange,
}) {
  const isPercentage = form.metodoCalculo === 'PORCENTAJE';
  const isFixed = form.metodoCalculo === 'FIJO';
  const isPerUnit = form.metodoCalculo === 'POR_UNIDAD';

  return (
    <div className="grid grid-cols-12 gap-3">
      <LabeledField label="Base" hint="Qué dato de la guía usa el cálculo." span="col-span-12 md:col-span-6 xl:col-span-3">
        <SearchableSelect
          value={form.unidadBase || ''}
          onChange={(value) => onChange('unidadBase', value)}
          options={baseOptions}
          placeholder="Seleccionar base"
          searchPlaceholder="Buscar base"
          emptyMessage="Sin bases"
        />
        {errors.unidadBase ? <span className="mt-1 block text-xs text-[rgb(var(--brand))]">{errors.unidadBase}</span> : null}
      </LabeledField>

      <LabeledField label="Método" hint="Fijo, por unidad o porcentaje." span="col-span-12 md:col-span-6 xl:col-span-3">
        <SearchableSelect
          value={form.metodoCalculo || ''}
          onChange={(value) => onChange('metodoCalculo', value)}
          options={methodOptions}
          placeholder="Seleccionar método"
          searchPlaceholder="Buscar método"
          emptyMessage="Sin métodos"
        />
        {errors.metodoCalculo ? <span className="mt-1 block text-xs text-[rgb(var(--brand))]">{errors.metodoCalculo}</span> : null}
      </LabeledField>

      <LabeledField label="Valor unitario / fijo" hint={isFixed ? 'Importe fijo por guía.' : 'Importe por unidad.'} span="col-span-12 md:col-span-6 xl:col-span-2">
        <input
          type="number"
          className={`${fieldClass} ${isPercentage ? 'opacity-50' : ''}`}
          value={form.valorUnitario}
          onChange={(e) => onChange('valorUnitario', e.target.value)}
          disabled={isPercentage}
        />
      </LabeledField>

      <LabeledField label="Porcentaje" hint="Sólo para método porcentual." span="col-span-12 md:col-span-6 xl:col-span-2">
        <input
          type="number"
          className={`${fieldClass} ${isPercentage ? '' : 'opacity-50'}`}
          value={form.porcentaje}
          onChange={(e) => onChange('porcentaje', e.target.value)}
          disabled={!isPercentage}
        />
      </LabeledField>

      <LabeledField label="Mínimo" hint="Piso del cálculo." span="col-span-12 md:col-span-4 xl:col-span-1">
        <input type="number" className={fieldClass} value={form.minimo} onChange={(e) => onChange('minimo', e.target.value)} />
      </LabeledField>

      <LabeledField label="Rango desde" hint="Inicio del escalón." span="col-span-12 md:col-span-4 xl:col-span-1">
        <input type="number" className={fieldClass} value={form.baseDesde} onChange={(e) => onChange('baseDesde', e.target.value)} />
      </LabeledField>

      <LabeledField label="Rango hasta" hint="Fin del escalón." span="col-span-12 md:col-span-4 xl:col-span-1">
        <input type="number" className={fieldClass} value={form.baseHasta} onChange={(e) => onChange('baseHasta', e.target.value)} />
      </LabeledField>

      <div className="col-span-12 rounded-2xl border border-[rgba(var(--brand),0.22)] bg-[rgba(var(--brand),0.08)] px-4 py-3">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[rgba(var(--muted),0.95)]">Lectura rápida</p>
        <p className="mt-2 text-sm leading-6 text-[rgba(var(--fg),0.86)]">{calculationSentence}</p>
        <p className="mt-2 text-xs text-[rgba(var(--muted),0.95)]">
          {isFixed ? 'Fijo mantiene el foco en un cargo por guía.' : isPerUnit ? 'Por unidad multiplica base física por valor unitario.' : 'Porcentaje usa sólo la base elegida y desactiva importe fijo.'}
        </p>
      </div>
    </div>
  );
}
